import React from 'react';

import {IProtectedRouteProps, Permission, NoAuth} from 'entities/user';

import {AppUrls} from '../shared/config/model/urls';
import {isTranslate} from '../shared/lib/lang';
import LoginPage from '../pages/auth/LoginPage';
import RegistrationPage from '../pages/auth/RegistrationPage';
import HomePage from '../pages/HomePage';
import ConfirmEmailPage from '../pages/auth/ConfirmEmailPage';
import ConfirmChangeEmailPage from '../pages/auth/ConfirmChangeEmailPage';
import PasswordResetInitPage from '../pages/auth/password/PasswordResetInitPage';
import PasswordResetSentPage from '../pages/auth/password/PasswordResetSentPage';
import NewPasswordPage from '../pages/auth/password/NewPasswordPage';
import ProfilePage from '../pages/ProfilePage';
import NotFound from '../pages/NotFound';
import HttpMonitorUnsubscribePage from '../pages/http/HttpMonitorUnsubscribePage';
import HttpMonitorsPage from '../pages/http/HttpMonitorsPage';
import StatusPagesPage from '../pages/statusPage/StatusPagesPage';
import PublicStatusPage from '../pages/statusPage/PublicStatusPage';
import PublicUserReportPage from '../pages/userReports/PublicUserReportPage';
import HttpMonitorLogsPage from '../pages/http/HttpMonitorLogsPage';
import HttpMonitorDetailsPage from '../pages/http/HttpMonitorDetailsPage';
import AdminTariffsPage from '../pages/admin/AdminTariffsPage';
import TariffsPage from '../pages/billing/TariffsPage';
import PaymentsPage from '../pages/billing/PaymentsPage';
import PaymentSuccessPage from '../pages/billing/PaymentSuccessPage';
import PaymentCancelPage from '../pages/billing/PaymentCancelPage';
import AdminUsersPage from '../pages/admin/AdminUsersPage';
import HttpIncidentsPage from '../pages/http/HttpIncidentsPage';
import DomainIncidentsPage from '../pages/domain/DomainIncidentsPage';
import UserReportsPage from '../pages/userReports/UserReportsPage';
import AdminPaymentsPage from '../pages/admin/AdminPaymentsPage';
import AdditionalEmailConfirm from '../pages/auth/AdditionalEmailConfirm';
import NotificationsUnsubscribePage from '../pages/email/NotificationsUnsubscribePage';
import AdminTariffVariantsPage from '../pages/admin/AdminTariffVariantsPage';
import EmailDeletePage from '../pages/email/EmailDeletePage';
import EmailWarningPage from '../pages/email/EmailWarningPage';
import EmailProblemPage from '../pages/email/EmailProblemPage';
import AdminReportsPage from '../pages/admin/AdminReportsPage';
import AdminCitiesPage from '../pages/admin/AdminCitiesPage';
import AdminLocationsPage from '../pages/admin/AdminLocationsPage';
import AdminPromoCodesPage from '../pages/admin/AdminPromoCodesPage';
import ConfirmDeletionPage from '../pages/auth/ConfirmDeletionPage';
import OAuthFinishPage from '../pages/auth/OAuthFinishPage';
import ServersPage from '../pages/server/ServersPage';
import ServerDetailsPage from '../pages/server/ServerDetailsPage';
import ServerIncidentsPage from '../pages/server/ServerIncidentsPage';
import DomainMonitorsPage from '../pages/domain/DomainMonitorsPage';
import DomainMonitorDetailsPage from '../pages/domain/DomainMonitorDetailsPage';
import PortMonitorsPage from '../pages/port/PortMonitorsPage';
import PortMonitorDetailsPage from '../pages/port/PortMonitorDetailsPage';
import PortIncidentsPage from '../pages/port/PortIncidentsPage';

export const routes: IProtectedRouteProps[] = [
    {
        path: AppUrls.LOGIN,
        element: <LoginPage/>,
    },
    {
        path: AppUrls.REGISTRATION,
        element: <RegistrationPage />,
    },
    {
        path: AppUrls.EMAIL_CONFIRMATION,
        element: <ConfirmEmailPage/>,
    },
    {
        path: AppUrls.ADDITIONAL_EMAIL_CONFIRM,
        element: <AdditionalEmailConfirm/>,
    },
    {
        path: AppUrls.CHANGE_EMAIL_CONFIRMATION,
        element: <ConfirmChangeEmailPage/>,
    },
    {
        path: AppUrls.HTTP_MONITOR_UNSUBSCRIBE,
        element: <HttpMonitorUnsubscribePage />,
    },
    {
        path: AppUrls.NOTIFICATIONS_UNSUBSCRIBE,
        element: <NotificationsUnsubscribePage />,
    },
    {
        path: AppUrls.PASSWORD_RESET,
        element: <PasswordResetInitPage/>,
    },
    {
        path: AppUrls.PASSWORD_RESET_SENT,
        element: <PasswordResetSentPage/>,
    },
    {
        path: AppUrls.NEW_PASSWORD,
        element: <NewPasswordPage/>,
    },
    {
        path: AppUrls.FORBIDDEN,
        element: <NoAuth/>,
    },
    {
        path: AppUrls.HOME,
        element: <HomePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.HTTP_MONITORS,
        element: <HttpMonitorsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.SERVERS,
        element: <ServersPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PORT_MONITORS,
        element: <PortMonitorsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.DOMAIN_MONITORS,
        element: <DomainMonitorsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.HTTP_INCIDENTS,
        element: <HttpIncidentsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.SERVER_INCIDENTS,
        element: <ServerIncidentsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PORT_INCIDENTS,
        element: <PortIncidentsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.DOMAIN_INCIDENTS,
        element: <DomainIncidentsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.STATUS_PAGES,
        element: <StatusPagesPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.USER_REPORTS,
        element: <UserReportsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.HTTP_MONITOR_LOGS,
        element: <HttpMonitorLogsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.HTTP_MONITOR_DETAILS,
        element: <HttpMonitorDetailsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.SERVER_DETAILS,
        element: <ServerDetailsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.DOMAIN_MONITOR_DETAILS,
        element: <DomainMonitorDetailsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PORT_MONITOR_DETAILS,
        element: <PortMonitorDetailsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PAYMENT_SUCCESS,
        element: <PaymentSuccessPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PAYMENT_CANCEL,
        element: <PaymentCancelPage/>,
        auth: [Permission.USER],
    },
    {
        path: isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS,
        element: <TariffsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.ADMIN_TARIFFS,
        element: <AdminTariffsPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_TARIFF_VARIANTS,
        element: <AdminTariffVariantsPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_PROMO_CODES,
        element: <AdminPromoCodesPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_PAYMENTS,
        element: <AdminPaymentsPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.PAYMENTS,
        element: <PaymentsPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.ADMIN_USERS,
        element: <AdminUsersPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_REPORTS,
        element: <AdminReportsPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_CITIES,
        element: <AdminCitiesPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.ADMIN_LOCATIONS,
        element: <AdminLocationsPage/>,
        auth: [Permission.ADMIN],
    },
    {
        path: AppUrls.SETTINGS,
        element: <ProfilePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.STATUS,
        element: <PublicStatusPage/>,
    },
    {
        path: AppUrls.USER_REPORT_VIEW,
        element: <PublicUserReportPage/>,
    },
    {
        path: AppUrls.NOT_FOUND,
        element: <NotFound/>,
    },
    {
        path: AppUrls.NEWS,
        element: <HomePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.EMAIL_WARNING,
        element: <EmailWarningPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.EMAIL_PROBLEM,
        element: <EmailProblemPage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.EMAIL_DELETE,
        element: <EmailDeletePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.PROMOS,
        element: <HomePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.SUPPORT,
        element: <HomePage/>,
        auth: [Permission.USER],
    },
    {
        path: AppUrls.USER_CONFIRM_DELETION,
        element: <ConfirmDeletionPage/>,
    },
    {
        path: '/oauth2/finish/:provider',
        element: <OAuthFinishPage />,
    },
];
